import { useMemo } from 'react';

type TWithId = { id: number };
type TTableData<T> = { key: React.Key } & T;

export const useTransformToTableData = <T extends TWithId>(data: T[]): TTableData<T>[] => {
  return useMemo(() => {
    return data.map((item) => ({
      key: item.id,
      ...item,
    }));
  }, [data]);
};
